import React, { PureComponent } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'

const Container = styled(View)`
  z-index: 100;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  flex: 1;
  opacity: 1;
`

export default class Overlay extends PureComponent {
  render () {
    return (
      <Container>
        {this.props.children}
      </Container>
    )
  }
}
